import { Injectable } from '@angular/core';

import { FrsReleaseBrowseService } from './frs.release-browse.service';
import { FrsReleaseDisplayService } from './frs.release-display.service';
import { FrsReleaseTiService } from './frs.release-ti.service';
import { FrsReleaseChartsService } from './frs.release-charts.service';

@Injectable()
export class FrsReleaseHelper {
    constructor(
        public browse: FrsReleaseBrowseService,
        public display: FrsReleaseDisplayService,
        public trackerItems: FrsReleaseTiService,
        public charts: FrsReleaseChartsService,
    ) {}
}